module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r5n1r2n-c5c26944ea82fdb48ee1d9352745b272.svg";